import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { TrendDimsDialog } from './TrendDimsDialog';

export const TrendDimsButton = ({
  codeToDim,
  codeToKpi,
  kpiCodes,
  trendSettings,
  trendValues,
  activeKpis,
  setTrendSettings,
  setActiveKpis,
}) => {
  const { openDialog } = useDialog();

  const openTrendDimsDialog = () => {
    openDialog(TrendDimsDialog, { codeToDim, codeToKpi, kpiCodes, trendSettings, trendValues, activeKpis }).then(
      (result) => {
        if (!result) return;
        setTrendSettings(result.trendSettings);
        setActiveKpis(result.activeKpis);
      },
    );
  };

  return <TitleButton icon={fas.faChartLine} toolTip="Trend Dimensions" onClick={openTrendDimsDialog} />;
};
